//
// Work Carousel Functions
//
import { Carousel, Navigation } from "@fancyapps/ui";

export default class WorkCarousel {
  constructor() {

    this.workCarousels = document.querySelectorAll('.js-work-carousel');

    const options = {
      slidesPerPage: 1,
      infinite: false,
      Navigation: {
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 41"><path d="M7.657 22.414 23.243 38l-2.829 2.828L0 20.414 20.414 0l2.829 2.828L7.657 18.414h20.171v4H7.657Z" fill="currentColor" /></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 41"><path d="M7.657 22.414 23.243 38l-2.829 2.828L0 20.414 20.414 0l2.829 2.828L7.657 18.414h20.171v4H7.657Z" fill="currentColor" /></svg>'
      },
      breakpoints: {
        "(min-width: 768px)": {
          slidesPerPage: 2,
        },
        "(max-width: 576px)": {
          Navigation: false,
        },
      },
    };

    this.workCarousels.forEach(workCarousel => {
      new Carousel(workCarousel, options);
    });

  }
}